/**
 * Offline reading: registers the service worker (Modules\Pwa serves /sw.js),
 * asks it to keep saved (♡) recipe pages, and fills the offline page with the
 * recipes this device can open without internet.
 */

const cfg = () => window.winonwebPwa || {};

/**
 * Keep (or stop keeping) a page for offline reading.
 *
 * @param {string}  url Page URL.
 * @param {boolean} on  Keep or forget.
 */
export function keepOffline( url, on ) {
	const sw = navigator.serviceWorker && navigator.serviceWorker.controller;
	if ( sw ) {
		sw.postMessage( { type: on ? 'keep' : 'forget', urls: [ url ] } );
	}
}

async function fillOfflinePage() {
	const list = document.querySelector( '[data-offline-list]' );
	if ( ! list ) {
		return;
	}
	document
		.querySelector( '[data-offline-retry]' )
		?.addEventListener( 'click', () => window.location.reload() );

	const seen = new Set();
	const items = [];
	if ( 'caches' in window ) {
		// Saved (♡) first, so a page in both caches is shown as saved.
		const names = ( await caches.keys() )
			.filter(
				( n ) =>
					n === 'smakota-saved-pages' ||
					n.startsWith( 'smakota-pages-' )
			)
			.sort( ( a ) => ( a === 'smakota-saved-pages' ? -1 : 1 ) );
		for ( const name of names ) {
			const cache = await caches.open( name );
			for ( const request of await cache.keys() ) {
				const url = request.url.split( '#' )[ 0 ];
				if ( seen.has( url ) || url.includes( 'smakota-offline' ) ) {
					continue;
				}
				seen.add( url );
				const res = await cache.match( request );
				const html = res ? await res.text() : '';
				// Recipes only: their pages carry the data-recipe root.
				if ( ! html.includes( 'data-recipe=' ) ) {
					continue;
				}
				const title = ( html.match( /<h1[^>]*>([^<]+)</ ) || [] )[ 1 ];
				if ( title ) {
					items.push( {
						url,
						title: title.trim(),
						saved: name === 'smakota-saved-pages',
					} );
				}
			}
		}
	}

	items.sort( ( a, b ) => Number( b.saved ) - Number( a.saved ) );
	list.replaceChildren(
		...items.slice( 0, 60 ).map( ( item ) => {
			const li = document.createElement( 'li' );
			const a = document.createElement( 'a' );
			a.href = item.url;
			a.textContent = ( item.saved ? '♡ ' : '' ) + item.title;
			li.append( a );
			return li;
		} )
	);
	document.querySelector( '[data-offline-empty]' ).hidden = items.length > 0;
}

export default function initPwa() {
	const { sw, scope } = cfg();
	if ( sw && 'serviceWorker' in navigator ) {
		window.addEventListener( 'load', () => {
			navigator.serviceWorker.register( sw, { scope } ).catch( () => {} );
		} );
	}
	fillOfflinePage();
}
